import * as moment from "moment";
import { ApiModel } from "./api-model";

export class BTSport extends ApiModel {
  btSportMappingId: number;
  btSportProductCode: string;
  sportName: string;
  liveDate: Date;
  liveEnd: Date;
  broadcastName: string;
  name: string;
  description: string;
  chapcaSportId: number;
  ageMarkId: number;
  ageMarkName: string;
  masterSportingEventId: number;
  sportingEventId: number;
  masterSportingEventName: string;
  sportingEventName: string;
  isSportingEvent: boolean;
  dayDiff: number;
  channel: string;

  typeId: number;
  groupId: number;
  labelId: number;

  active: boolean;
  version: string;

  constructor(data: any) {
    super(data);
    this.active = false;
    this.liveDate = new Date(this.liveDate);
    this.liveEnd = new Date(this.liveEnd);
  }

  GetTimeString() {
    return (
      moment(this.liveDate).format("DD/MM/YYYY HH:mm") +
      "-" +
      moment(this.liveEnd).format("HH:mm")
    );
  }

  GetDescriptionShort() {
    if (this.description.length > 70) {
      return this.description.slice(0, 70) + "...";
    } else {
      return this.description;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/bt-sport.ts